import DNSlideTab from '@/design-components/organisms/dnslide-tab';
import DNSlideTabItem from '@/design-components/organisms/dnslide-tab/dnslide-tab-item';
import { NearbyPharmacySearchTabsVo } from '@/types/pharmacy';

import EmptyTabsSkeleton from '../../../pharmacies-find/ui/EmptyTabsSkeleton';

interface Props {
  tabs?: NearbyPharmacySearchTabsVo[];
  selectedTab: NearbyPharmacySearchTabsVo | null;
  onClickTab: (tab: NearbyPharmacySearchTabsVo) => void;
}
const PharmacyMapHeaderTabs = ({ tabs, selectedTab, onClickTab }: Props) => {
  return (
    <>
      {tabs ? (
        <DNSlideTab value={selectedTab?.name} className={'z-[2] bg-white'}>
          {tabs.map((tab) => (
            <DNSlideTabItem
              key={tab.id}
              label={tab.name}
              isActive={selectedTab?.id === tab.id}
              onClick={() => {
                onClickTab(tab);
              }}
            />
          ))}
        </DNSlideTab>
      ) : (
        <EmptyTabsSkeleton />
      )}
    </>
  );
};

export default PharmacyMapHeaderTabs;
